module.exports = __webpack_public_path__ + "static/media/tab.c99c231c.png";